<template>
  <main class="homepage">
    <Intro />
    <VideoReviews />
    <TourheroFeatures has-cta variant="primary" :reasons="HomeReasons">
      <template #title> Why choose <em>TourHero</em> </template>
      <template #description>
        {{ HomeDescription }}
      </template>
    </TourheroFeatures>
    <TripStats />
    <TextReviews />
    <FutureTrips />
    <GetStarted />
    <PlanTripBanner />
    <PressCoverage :press-items="PressItems" />

    <section id="section:faqs" class="faq-section">
      <TwinColorTitle>TourHero<br /><em>Frequently Asked Questions</em></TwinColorTitle>
      <FaqList page="home" />
    </section>

    <BlogPosts />
  </main>
</template>

<script setup lang="ts">
import { HomeReasons, HomeDescription, PressItems } from '@/constants'
import PressCoverage from '@/components/PressCoverage.vue'
import Intro from '@/modules/Home/Intro.vue'
import VideoReviews from '@/modules/Home/VideoReviews.vue'
import TourheroFeatures from '@/modules/LandingPages/Components/TourheroFeatures.vue'
import TripStats from '@/modules/Home/TripStats.vue'
import TextReviews from '@/modules/Home/TextReviews.vue'
import FutureTrips from '@/modules/Home/FutureTrips.vue'
import BlogPosts from '@/modules/Home/BlogPosts.vue'
import GetStarted from '@/modules/LandingPages/Components/GetStarted.vue'
import PlanTripBanner from '@/modules/LandingPages/Components/PlanTripBanner.vue'
import { onMounted } from 'vue'
import { useSetReferrerInUrl } from '../helpers/hooks'
import FaqList from '@/modules/SupportHub/FaqList.vue'
import TwinColorTitle from '@/components/Theme2/TwinColorTitle.vue'

onMounted(() => {
  useSetReferrerInUrl()
})
</script>

<style lang="scss" scoped>
.homepage {
  @include base-font;
  @include flex-column;
  margin-bottom: 45px;
  gap: 64px;
}

main > section {
  @include flex-column;
}

.faq-section {
  @include flex-column(32px);
  width: 100%;
  max-width: 867px;
  margin-inline: auto;
}
</style>
